import { createContext, useContext } from "react";
import { IDetail, ICart } from "../../../types/menu";

interface RecommendDetailContextType {
  recommendItem: IDetail | null;
  setRecommendItem: (detail: IDetail | null) => void;
  selectRequired: boolean;
  setSelectRequired: (required: boolean) => void;
  handleClose: () => void;
  handleAddCount: (item: ICart) => void;
  handleSubCount: (item: ICart) => void;
  handleAddtoCart: (e: any, orderItems: IDetail) => Promise<void>;
  checkLimitCountText: () => string;
}

export const RecommendDetailContext = createContext<RecommendDetailContextType | null>(null);

export const useRecommendDetail = () => {
  const context = useContext(RecommendDetailContext);
  if (!context) {
    throw new Error("useItemDetail must be used within an ItemDetailProvider");
  }
  return context;
};
